<script>
  import UserPage from "../UserPage.svelte";
  // import Gunjs from "./Gunjs.svelte";
  import AdminPage from "./AdminPage.svelte";
  import TeacherPage from "../teacher/TeacherPage.svelte";
  import HeadTeacher from "../teacher/HeadTeacher.svelte";
  import Loading from "../teacher/Loading.svelte";
  import { user } from "../userStore.js";
  let menu = 2;
</script>

<style>
  .main {
    text-align: center;
    /* padding: 1em; */
    max-width: 240px;
    margin: 0 auto;
    top: 0px;
  }

  /* @media (min-width: 640px) {
    .main {
      max-width: none;
    }
  }   */

  ul#menu {
    display: inline;
    padding: 0px !important;
    /* border: #ff3e00; */
    /* border-style: dashed; */
  }

  ul#menu li {
    display: inline;
  }

  ul#menu li .active {
    font-weight: bold;
  }

  /* h1 {
    color: #ff3e00;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
    margin: 0;
  } */
</style>

<div class="main">
  {#if $user.loggedin && $user.admin}
    <!-- <ul id="menu" class:hidden={prod}> -->
    <ul id="menu">
      <li>
        <a
          href="/"
          on:click|preventDefault={() => (menu = 1)}
          class:active={menu === 1}>
          User
        </a>
      </li>
      |
      <li>
        <a
          href="/"
          on:click|preventDefault={() => (menu = 2)}
          class:active={menu === 2}>
          Admin
        </a>
      </li>
      |
      <li>
        <a
          href="/"
          on:click|preventDefault={() => (menu = 3)}
          class:active={menu === 3}>
          Teacher
        </a>
      </li>
      |
      <li>
        <a
          href="/"
          on:click|preventDefault={() => (menu = 4)}
          class:active={menu === 4}>
          HeadTeacher
        </a>
      </li>
      |
      <li>
        <a href="/" on:click|preventDefault={() => localStorage.clear()}>
          Clear
        </a>
      </li>
      <!-- |
      <li>
        <a
          href="/"
          on:click|preventDefault={() => (menu = 5)}
          class:active={menu === 5}>
          Gunjs
        </a>
      </li> -->
    </ul>

    {#if menu === 1}
      <UserPage />
    {/if}
    {#if menu === 2}
      <AdminPage />
    {/if}
    {#if menu === 3}
      <TeacherPage />
    {/if}
    {#if menu === 4}
      <HeadTeacher />
    {/if}
    <!-- {#if menu === 5}
    <Gunjs />
    {/if} -->
    {#if menu === 6}
      <Loading />
    {/if}
  {/if}
</div>
